/* eslint-disable no-use-before-define, no-unused-vars, no-throw-literal */
import { accessTokenItemName } from "../actions/user";
import { MARKETPLACE_API_URL } from "../../config.js";
import storage from "../../utils/storage";
import { Platform } from "react-native";

const getNowUnix = () => {
  const nowDate = new Date();
  return Math.ceil(nowDate.getTime() / 1000); // convert from ms to s
};

const fetchMiddleware = (store) => (next) => (action) => {
  next(action);
  let options;

  let headers;
  if (action.meta && action.meta.headers !== undefined) {
    headers = action.meta.headers;
  } else {
    headers = {
      "Content-Type": "application/json",
    };
  }

  if (action.meta && action.meta.endpoint) {
    if (action.meta.rpToken) {
      doFetch(action.meta.rpToken, action, options, next, store, headers);
    } else {
      storage
        .load({ key: accessTokenItemName })
        .then((ret) => {
          if (Platform.OS !== "web") {
            storage
              .load({ key: "expiry" })
              .then((exp) => {
                if (exp - 300 < getNowUnix()) {
                  refreshThenDoFetch(
                    ret,
                    action,
                    options,
                    next,
                    store,
                    headers
                  );
                } else {
                  doFetch(ret, action, options, next, store, headers);
                }
              })
              .catch(() => {
                doFetch("", action, options, next, store, headers);
              });
          } else {
            doFetch(ret, action, options, next, store, headers);
          }
        })
        .catch(() => {
          doFetch("", action, options, next, store, headers);
        });
    }
  }
};

const refreshThenDoFetch = (rpToken, action, options, next, store, headers) => {
  headers.Authorization = "Bearer " + rpToken;
  headers["Reposit-Auth"] = "Stateless";
  storage.load({ key: "refreshToken" }).then((refreshToken) => {
    const body = JSON.stringify({ refresh_token: refreshToken });
    const url = MARKETPLACE_API_URL + "/auth/refresh/";
    fetch(url, { method: "post", headers: headers, body: body })
      .then(function (response) {
        if (response && response.status === 401) {
          storage.remove({ key: accessTokenItemName });
          next({ type: "LOGOUT_STORE" });
          let ex = new Error();
          ex.isBadAuth = true;
          throw ex;
        } else if (response && response.status === 403) {
          let ex = new Error();
          ex.notAuthorized = true;
          throw ex;
        } else if (response.status >= 400 && response.status < 600) {
          // let ex = new Error("Bad response from server");
          // ex.response = response;
          throw { response: response };
        } else if (response.status === 204) {
          // No Content
          return null;
        }
        return response.json();
      })
      .then(function (loginResponse) {
        storage.save({
          key: accessTokenItemName,
          data: loginResponse.access_token,
        });
        storage.save({ key: "expiry", data: loginResponse.expires_at });
        headers.Authorization = "Bearer " + loginResponse.access_token;

        doFetch(
          loginResponse.access_token,
          action,
          options,
          next,
          store,
          headers
        );
      })
      .catch(function (ex) {
        console.log(ex);
      });
  });
};

const doFetch = (rpToken, action, options, next, store, headers) => {
  if (Platform.OS !== "web") {
    headers["Reposit-Auth"] = "Stateless";
  }

  let endpoint;
  if (action.meta.endpoint.startsWith("http")) {
    endpoint = action.meta.endpoint;
  } else if (action.meta.noAuthorizationHeader) {
    endpoint = MARKETPLACE_API_URL + action.meta.endpoint;
  } else {
    endpoint = MARKETPLACE_API_URL + action.meta.endpoint;
    if (headers.Authorization === undefined) {
      headers.Authorization = "Bearer " + rpToken;
    }
  }
  switch (action.meta.method) {
    case "PUT":
    case "POST":
      options = {
        method: action.meta.method ? action.meta.method.toLowerCase() : "post",
        headers: headers,
      };

      if (
        action.meta.body &&
        options.headers["Content-Type"] === "application/json"
      ) {
        options.body = JSON.stringify(action.meta.body);
      } else {
        options.body = action.meta.body;
      }

      break;
    default:
      options = {
        method: action.meta.method ? action.meta.method.toLowerCase() : "get",
        headers: headers,
      };
  }

  // Override any default headers with those pass in by the action.
  if (action.meta.headers) {
    const actionHeaders = action.meta.headers;
    for (var prop in actionHeaders) {
      if (options.headers[prop]) {
        options.headers[prop] = actionHeaders[prop];
      }
    }
  }

  if (!action.meta.endpoint.startsWith("http") && Platform.OS === "web") {
    // This enables cookies to be sent with fetch requests if we are making default requests
    // to the Fleet API.
    options.credentials = "include";
  }
  fetch(endpoint, options)
    .then(function (response) {
      if (response && response.status === 401) {
        storage.remove({ key: accessTokenItemName });
        next({ type: "LOGOUT_STORE" });
        let ex = new Error();
        ex.isBadAuth = true;
        throw ex;
      } else if (response && response.status === 403) {
        next({ type: "LOGOUT_STORE" });
        let ex = new Error();
        ex.notAuthorized = true;
        throw ex;
      } else if (response.status >= 400 && response.status < 600) {
        // let ex = new Error("Bad response from server");
        // ex.response = response;
        throw { response: response };
      } else if (response.status === 204) {
        // No Content
        return null;
      }
      return response.json();
    })
    .then(function (json) {
      if (action.meta.successMessage) {
        // { success }
      }
      if (action.meta.success) {
        const successResult = action.meta.success(json, action.payload);
        // Check to see if the result has a type attribute, if it does then
        // assume its a Redux action and dispatch it.
        if (successResult && successResult.type) {
          // This is quite heavy handed, but `next` refers to an
          // un-middleware'd `dispatch` which means that if the
          // successResult needs to invoke another request it won't go through
          // this fetchMiddleware. As such we force if through the middle ware
          fetchMiddleware(store)(next)(successResult);
        }
      }
    })
    .catch(function (ex) {
      if (ex.isBadAuth) {
        // { bad auth}
        next({ type: "LOGOUT_STORE" });
      }
      if (ex.notAuthorized) {
        return;
      }
      if (action.meta.errorMessage) {
        // { error }
      }
      if (action.meta.error) {
        var errorResult = action.meta.error(action.payload, ex.response);
        // Check to see if the result has a type attribute, if it does then
        // assume its a Redux action and dispatch it.
        if (errorResult && errorResult.type) {
          next(errorResult);
        }
      }
      return ex;
    })
    .then(function (ex) {
      if (action.meta.finally) {
        const finalResult = action.meta.finally(action.payload);
        // Check to see if the result has a type attribute, if it does then
        // assume its a Redux action and dispatch it.
        if (finalResult && finalResult.type) {
          // This is quite heavy handed, but `next` refers to an
          // un-middleware'd `dispatch` which means that if the
          // successResult needs to invoke another request it won't go through
          // this fetchMiddleware. As such we force if through the middle ware
          fetchMiddleware(store)(next)(finalResult);
        }
      }
      if (ex) {
        throw ex;
      }
    });
};
export { fetchMiddleware };



// WEBPACK FOOTER //
// ./src/redux/middleware/fetchMiddleware.js